import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import './YourRelationshipSection.scss'
import { format } from 'date-fns'
import { IoIosList } from 'react-icons/io'
import { getMainDepartamentOfRP } from 'app/Helpers/ResidentialPlans.helper'

const YourRelationshipSection = React.memo(({ residentialPlanEntity }) => {
  const [relationshipData, setRelationshipData] = useState({})
  const [mainFireDepartmentName, setMainDepartmentName] = useState('')

  useEffect(() => {
    if (residentialPlanEntity) {
      setRelationshipData(residentialPlanEntity)
      setMainDepartmentName(getMainDepartamentOfRP(residentialPlanEntity))
    }
  }, [residentialPlanEntity])

  const renderUnit = (unitType, isOther) => {
    switch (unitType) {
      case 1:
        return <span>Front</span>
      case 2:
        return <span>Rear</span>
      case 3:
        return <span>Left</span>
      case 4:
        return <span>Right</span>
      case 5:
        return <span>Middle Unit</span>
      case 6:
        return <span>Basement Unit</span>
      case 7:
        return <span>First Floor</span>
      case 8:
        return <span>Second Floor</span>
      case 9:
        return <span>{isOther}</span>
      default:
        return ''
    }
  }

  return (
    <div className="your-relationship-section">
      <h2>Property overview</h2>

      <div className="relationship-section">
        <Container maxWidth="lg">
          <Grid container spacing={2}>
            <Grid size={12}></Grid>
            <Grid size={12}>
              <form noValidate autoComplete="off">
                <Grid container>
                  <Grid size={12} className="container-field">
                    {relationshipData.yourRelationShip && (
                      <Grid>
                        <label className="main-title-label">
                          Property information provided by:
                        </label>
                        <Grid className="container-field">
                          {(() => {
                            switch (relationshipData.yourRelationShip) {
                              case 1:
                                return <label> Resident</label>
                              case 2:
                                return <label> Family Member</label>
                              case 3:
                                return <label> Neighbor</label>
                              case 4:
                                return <label> Owner/Landlord</label>
                              case 5:
                                return <label> Caregiver</label>
                              case 6:
                                return (
                                  <label>
                                    {' '}
                                    {relationshipData.yourRelationShipOther &&
                                      relationshipData.yourRelationShipOther}
                                  </label>
                                )
                              default:
                                return ''
                            }
                          })()}
                        </Grid>
                      </Grid>
                    )}

                    <Grid>
                      <label className="main-title-label">Location:</label>
                      {residentialPlanEntity.propertyLocation && (
                        <Grid className="container-field">
                          {residentialPlanEntity.propertyLocation.streetNumber && (
                            <span>{`${residentialPlanEntity.propertyLocation.streetNumber}`}</span>
                          )}{' '}
                          {residentialPlanEntity.propertyLocation.streetName && (
                            <span>{`${residentialPlanEntity.propertyLocation.streetName}, `}</span>
                          )}
                          {residentialPlanEntity.propertyLocation.apartmentNumber && (
                            <span>{`APT. ${residentialPlanEntity.propertyLocation.apartmentNumber}, `}</span>
                          )}
                          {residentialPlanEntity.propertyLocation.floor && (
                            <span>{`Floor ${residentialPlanEntity.propertyLocation.floor}, `}</span>
                          )}
                          {residentialPlanEntity.propertyLocation.city && (
                            <span>{`${residentialPlanEntity.propertyLocation.city}, `}</span>
                          )}
                          {residentialPlanEntity.propertyLocation.state && (
                            <span>{`${residentialPlanEntity.propertyLocation.state}, `} </span>
                          )}
                          {residentialPlanEntity.propertyLocation.country && (
                            <span>{`${residentialPlanEntity.propertyLocation.country}`}</span>
                          )}
                        </Grid>
                      )}
                    </Grid>

                    {relationshipData.propertyTypeId && (
                      <Grid>
                        <label className="main-title-label"> Property Type:</label>
                        <Grid className="container-field">
                          {(() => {
                            switch (relationshipData.propertyTypeId) {
                              case 1:
                                return <label> Single Family Unit</label>
                              case 2:
                                return <label> Multi-family Unit</label>
                              case 3:
                                return <label> Mobile Unit</label>
                              case 4:
                                return <label> Apartment Building</label>
                              case 5:
                                return <label> Home with Attached Business</label>
                              case 6:
                                return (
                                  <span>
                                    {relationshipData.propertyTypeOther &&
                                      relationshipData.propertyTypeOther}
                                  </span>
                                )
                              default:
                                return ''
                            }
                          })()}
                        </Grid>
                      </Grid>
                    )}

                    {relationshipData.propertyLocation &&
                      (relationshipData.propertyLocation.multiUnitType ||
                        relationshipData.propertyLocation.unitNumber) && (
                        <Grid>
                          <label className="main-title-label">
                            {' '}
                            Multi-Family home, property is:
                          </label>
                          <Grid className="container-field">
                            <>
                              {relationshipData.propertyLocation.unitNumber &&
                                `${relationshipData.propertyLocation.unitNumber}${
                                  relationshipData.propertyLocation.multiUnitType.length > 0
                                    ? ',\u00A0'
                                    : ''
                                }`}
                            </>
                            {relationshipData.propertyLocation.multiUnitType &&
                              relationshipData.propertyLocation.multiUnitType.map((unitType, i) => {
                                const isOther =
                                  relationshipData.propertyLocation.multiUnitTypeOther &&
                                  relationshipData.propertyLocation.multiUnitTypeOther
                                return (
                                  <>
                                    {renderUnit(unitType, isOther)}
                                    {i < relationshipData.propertyLocation.multiUnitType.length - 1
                                      ? ',\u00A0'
                                      : ''}
                                  </>
                                )
                              })}
                          </Grid>
                        </Grid>
                      )}

                    {residentialPlanEntity.seasonalResidence &&
                      residentialPlanEntity.seasonalResidence.isSeasonal && (
                        <Grid>
                          <label className="main-title-label">Seasonal Residence:</label>
                          <Grid className="container-field">
                            {residentialPlanEntity.seasonalResidence.from &&
                              format(
                                Date.parse(residentialPlanEntity.seasonalResidence.from),
                                'MMMM dd'
                              )}{' '}
                            <label>to</label>{' '}
                            {residentialPlanEntity.seasonalResidence.to &&
                              format(
                                Date.parse(residentialPlanEntity.seasonalResidence.to),
                                'MMMM dd'
                              )}
                          </Grid>
                        </Grid>
                      )}

                    {residentialPlanEntity.fireDepartmentIdentifier &&
                      residentialPlanEntity.sharedFireDepartments && (
                        <Grid>
                          <label className="main-title-label">
                            Main emergency response agency:
                          </label>
                          <Grid className="container-field">
                            <label>{mainFireDepartmentName}</label>
                          </Grid>
                        </Grid>
                      )}

                    {residentialPlanEntity && residentialPlanEntity.concerningPrivacy && (
                      <Grid>
                        <label className="main-title-label">
                          Privacy level selected for this information:
                        </label>
                        {residentialPlanEntity.sharedFireDepartments.map((department) => {
                          return (
                            <div key={department.fireDepartmentIdentifier}>
                              <IoIosList />
                              <label>
                                {department.fireDepartmentName}{' '}
                                {department.shareMutualAids ? 'and its mutual aids' : ''}
                              </label>
                            </div>
                          )
                        })}
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Container>
      </div>
    </div>
  )
})

export default YourRelationshipSection
